<template>
    <div class="p-3">
        <h3>Update Pasien Details</h3>
        <hr>

        <div class="row">
            <div class="col-sm-6">
                <h4 class="mb-3">Data Pasien Update</h4>

                <div class="card">
                    <div class="card-header text-white bg-primary">Update Pasien</div>
                    <div class="card-body">
                        <div class="row mb-3 fw-bold">
                            <div class="col-sm-4 alert alert-primary text-end">Field</div>
                            <div class="col-sm-3 alert alert-primary text-center">Data Lama</div>
                            <div class="col-sm-5 alert alert-primary text-center">Data Baru</div>
                        </div>
                        <template v-for="(pasien, idx) in updated_pasiens">
                            <div class="row mb-3" :key="idx" v-if="input_labels[idx]">
                                <label :for="idx" class="col-sm-4 col-form-label text-end">{{ input_labels[idx] }}</label>
                                <div class="col-sm-3">
                                    <input type="text" :name="`${idx}-original`" :id="`${idx}1`" :value="detail_pasien[idx]" disabled class="form-control">
                                </div>
                                <div class="col-sm-5">
                                    <input :name="idx" v-if="inArray(idx, input_date)" type="date" :id="idx" class="form-control" v-model="updated_pasiens[idx]" @change="validate(idx)">
                                    <input :name="idx" v-if="inArray(idx, input_number)" type="number" :id="idx" class="form-control" v-model="updated_pasiens[idx]" @change="validate(idx)">
                                    <input :name="idx" v-if="inArray(idx, input_disabled)" type="number" :id="idx" class="form-control" v-model="updated_pasiens[idx]" @change="validate(idx)">
                                    <input :name="idx" v-if="!inArray(idx, input_filtered)" type="text" :id="idx" class="form-control" v-model="updated_pasiens[idx]" @change="validate(idx)">
    
                                    <template v-if="inArray(idx, input_jk)">
                                        <select class="form-select" v-model="updated_pasiens[idx]">
                                            <option value="">--- Pilih Jenis Kelamin ---</option>
                                            <option value="Laki-laki">Laki-laki</option>
                                            <option value="Perempuan">Perempuan</option>
                                        </select>
                                    </template>
    
                                    <template v-if="inArray(idx, input_perkawinan)">
                                        <select class="form-select" v-model="updated_pasiens[idx]">
                                            <option value="">--- Pilih Perkawinan ---</option>
                                            <option v-for="kawin, idx_kawin in master_perkawinan" :key="idx_kawin" :value="kawin.NmKawin">{{ kawin.NmKawin }}</option>
                                        </select>
                                    </template>
    
                                    <template v-if="inArray(idx, input_agama)">
                                        <select class="form-select" v-model="updated_pasiens[idx]">
                                            <option value="">--- Pilih Agama ---</option>
                                            <option v-for="agama, idx_agama in master_agama" :key="idx_agama" :value="agama.NmAgama">{{ agama.NmAgama }}</option>
                                        </select>
                                    </template>
    
                                    <template v-if="inArray(idx, input_pendidikan)">
                                        <select class="form-select" v-model="updated_pasiens[idx]">
                                            <option value="">--- Pilih Pendidikan ---</option>
                                            <option v-for="pendidikan, idx_pendidikan in master_pendidikan" :key="idx_pendidikan" :value="pendidikan.NmDidik">{{ pendidikan.NmDidik }}</option>
                                        </select>
                                    </template>
                                </div>
                            </div>
                        </template>

                        <div class="row">
                            <div class="col text-end">
                                <button class="btn btn-sm btn-success" @click="savePasien">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            Medrec: '',
            detail_pasien: [],
            master_pasiens: [],
            updated_pasiens: [],
            filter: {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
                page: 1,
            },
            input_labels: {
                'Medrec': 'No Rekam Medis',
                'Firstname': 'Nama Lengkap',
                'Pod': 'Tempat Lahir',
                'Bod': 'Tangal Lahir',
                'UmurThn': 'Umur (Tahun)',
                'UmurBln': 'Umur (Bulan)',
                'UmurHr': 'Umur (Hari)',
                'Sex': 'Jenis Kelamin',
                'GolDarah': 'Golongan Darah',
                'RHDarah': 'RH Darah',
                'WargaNegara': 'Warga Negara',
                'NoIden': 'NIK',
                'Perkawinan': 'Status Perkawinan',
                'Agama': 'Agama',
                'Pendidikan': 'Pendidikan',
                'NamaAyah': 'Nama Ayah',
                'NamaIbu': 'Nama Ibu',
                'AskesNo': 'No Kartu BPJS',
                'TglDaftar': 'Tanggal Daftar',
                'Address': 'Alamat',
                'City': 'Kota',
                'Propinsi': 'Propinsi',
                'Kecamatan': 'Kecamatan',
                'Kelurahan': 'Kelurahan',
                'KdPos': 'Kode Pos',
                'Phone': 'No Telp',
                'Kategori': 'Kategori',
                'Pekerjaan': 'Pekerjaan',
                'NamaPJ': 'Nama Penanggung Jawab',
                'HubunganPJ': 'Hubungan Penanggung Jawab',
                'PekerjaanPJ': 'Pekerjaan Penanggung Jawab',
                'PhonePJ': 'No Telp Penanggung Jawab',
                'AlamatPJ': 'Alamat Penanggung Jawab',
                'NmSuku': 'Nama Suku',
                'Keyakinan': 'Keyakinan',
                'alamat_ktp': 'Alamat KTP',
            },
            input_date: ['Bod', 'TglDaftar', 'tgl_lahir', 'tgl_daftar', 'merged_date'],
            input_number: ['UmurThn', 'UmurBln', 'UmurHr'],
            input_disabled: ['ValidUser'],
            input_jk: ['Sex'],
            input_perkawinan: ['Perkawinan'],
            input_agama: ['Agama'],
            input_pendidikan: ['Pendidikan'],
            input_filtered: [],
            master_perkawinan: [],
            master_agama: [],
            master_pendidikan: [],
            data_provinsi: [],
            data_kota: [],
            data_kecamatan: [],
            data_kelurahan: [],
        }
    },
    created() {
        this.Medrec = this.$route.params.Medrec
        this.input_filtered = [...this.input_date, ...this.input_number, ...this.input_number, ...this.input_jk, ...this.input_perkawinan, ...this.input_agama, ...this.input_pendidikan]
    },
    mounted() {
        this.getDetailPasien()
        this.getDataMaster()
    },
    updated() {
        this.updated_pasiens.tgl_lahir = this.updated_pasiens.Bod
        this.updated_pasiens.tgl_daftar = this.updated_pasiens.TglDaftar
        this.updated_pasiens.no_telp = this.updated_pasiens.Phone
    },
    methods: {
        getDetailPasien() {
            const uri = `/api/update-pasien/get-detail-pasien?Medrec=${this.Medrec}`

            this.axios.get(uri).then(response => {
                const status = response.data.status

                if (status == 'success') {
                    this.detail_pasien = response.data.pasien
                    this.updated_pasiens = { ...this.detail_pasien }
                }
            })
        },
        validate(field) {
            console.log('field:', field)
            console.log('updated_pasiens:', this.updated_pasiens)
        },
        savePasien() {
            const uri = '/api/update-pasien/save-pasien'

            this.axios.post(uri, {data_pasien: this.updated_pasiens}).then(response => {
                if (response.data.status == 'success') {
                    this.$router.push({
                        name: 'update_pasien'
                    })
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            })
        },
        getDataMaster() {
            const uri = '/api/master/get-all-master'

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.master_perkawinan = response.data.data_masters.perkawinan ?? []
                    this.master_agama = response.data.data_masters.agama ?? []
                    this.master_pendidikan = response.data.data_masters.pendidikan ?? []
                }
            })
        },
        getProvinsi() {
            const uri = '/api/paster/get-provinsi'

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.data_provinsi = response.data.provinsi ?? []
                }
            })
        },
        getKota() {
            const uri = `/api/paster/get-kota?prov=${this.updated_pasiens.kd_prov}`

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.data_kota = response.data.kota ?? []
                }
            })
        },
        getKecamatan() {
            const uri = `/api/paster/get-kecamatan?kota=${this.updated_pasiens.kd_kota}`

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.data_kecamatan = response.data.kecamatan ?? []
                }
            })
        },
        getKelurahan() {
            const uri = `/api/paster/get-kelurahan?kec=${this.updated_pasiens.kd_kec}`

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.data_kelurahan = response.data.kelurahan ?? []
                }
            })
        },
    }
}
</script>